module.exports = __webpack_public_path__ + "media/images/bnr-video-19d10b628fa784a0927ce678c4a21687.png";